import Fingerprint2 from 'fingerprintjs2';

const withDelimiter = (value, delimiter = ";") => {
  return (value && value.length >= 0) ? value.join(delimiter) : '';
}

const flatten = (data) => {
  const map = data.reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {});
  map.available_resolution = withDelimiter(map.available_resolution);
  map.resolution = withDelimiter(map.resolution);
  map.touch_support = withDelimiter(map.touch_support);
  map.js_fonts = withDelimiter(map.js_fonts);
  map.regular_plugins = "[" + withDelimiter(map.regular_plugins, '], [') + "]";
  return map;
};

const getFingerprint = (callback) => setTimeout(() => {
  new Fingerprint2().get((device_id, components) => {
    if (callback) {
      callback(device_id, components);
    }
  });
}, 1000);

const emmitEvent = (callback) => getFingerprint((device_id, components) => {
  const payload = {
    name: "Fingerprint",
    device_id,
    ...flatten(components),
  };

  Jigsaw.addEvents(payload);
  
  if (callback) {
    callback(payload);
  }
});

export default {
  getFingerprint,
  emmitEvent,
};